import styled from "styled-components";

export const FiltersContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
`;

export const SearchContainer = styled.div`
  min-width: 200px;
`; 